import { useSelector } from 'react-redux';
import { AccountingState } from '@mews-commander/data-access';
import { getOrderItem } from '@mews-commander/legacy-entities/src/ducks/orderItems';
import { ApplicationState } from '@mews-commander/types';
import { Dash, SpacedForwardSlash } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ModalLink } from '../Link';
import { BillLinkWithBillId } from './BillLinkWithBillId';
import { useBillingUrl } from './useBillingUrl';

interface BillLinkWithOrderItemIdProps {
    orderItemId: string;
    groupId?: string;
}

export const BillLinkWithOrderItemId = ({ orderItemId, groupId }: BillLinkWithOrderItemIdProps) => {
    const orderItem = useSelector((state: ApplicationState) => getOrderItem(state, { id: orderItemId }));
    const billingUrl = useBillingUrl({
        accountId: orderItem?.ownerId,
        groupId,
        billId: orderItem?.billId || undefined,
        orderItemId,
    });

    const isOrderItemBillable =
        orderItem?.accountingState !== AccountingState.Canceled &&
        orderItem?.accountingState !== AccountingState.Inactive;

    if (!orderItem || !billingUrl || !isOrderItemBillable) return <Dash />;

    if (orderItem.billId && orderItem.billId !== orderItem.ownerId) {
        return <BillLinkWithBillId billId={orderItem.billId} groupId={groupId} orderItemIdToHighlight={orderItemId} />;
    }

    return (
        <ModalLink data-unassigned-items-link={orderItemId} url={billingUrl}>
            <LocalizedText textKey={TextKey.UnpaidBillItems} />
            {SpacedForwardSlash}
            <LocalizedText textKey={TextKey.DepositPlural} />
        </ModalLink>
    );
};
